import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
import { parseQuery } from '@/utils/helpers';
import scrollTo from '@/utils/scrollTo';
import { MODALS } from '@/components/app/app-modals/modals-constants';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';
import seoMetaMixin from '@/mixins/seoMeta';

let toRoute = '';
let restore = true;

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
    seoMetaMixin,
  ],
  components: {
    staticPageHeader,
  },
  metaInfo() {
    return this.buildSeoMeta({
      title: 'Terms and Conditions',
    });
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.TERMS)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      })
      .then(() => this.loaderRemove(document.body))
      .then(() => {
        const query = parseQuery(window.location.search);
        if (query && query.section) {
          this.$nextTick(() => {
            const toWhere = document.getElementById(query.section);
            if (!toWhere) {
              return;
            }
            let topOffset = 16; // add some padding
            const header = document.querySelector('.app-layout__header');
            if (header) {
              topOffset += header.offsetHeight;
            }
            scrollTo(toWhere, 0, 'linear', null, topOffset);
          });
        }
      })
      .catch(() => this.loaderRemove(document.body));
  },
  // beforeDestroy() {
  //   // firest after router loop
  //   if (restore) {
  //     store.dispatch('popup/restorePopup', toRoute);
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    const popup = to.params.noPopup ? null : null;
    store.dispatch('popup/rememberPopup', {
      route: from.name,
      popup,
    });
    next();
  },
  beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'privacy-policy';
    toRoute = to.name;
    next();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-terms-and-conditions/page-terms-and-conditions.js